import { Api } from "./base";

const _headers = () => {
  return {
    Authorization:
      "JWT " + require("store").default.getState().onboard.user.auth_token,
    "Content-Type": "application/json"
  };
};

export default {
  getImages(offset, filterString = "") {
    return Api.getCsv(`/wg_and_pictionary/v1/admin-pictionary-images?offset=${offset}${filterString}`, _headers());
  },
  getImageById(id) {
    return Api.get(`/wg_and_pictionary/v1/admin-pictionary-images/${id}/`, _headers());
  },
  createImage(payload) {
    return Api.post(`/wg_and_pictionary/v1/admin-pictionary-images`, payload, _headers());
  },
  updateImageById(id, payload) {
    return Api.put(`/wg_and_pictionary/v1/admin-pictionary-images/${id}`, payload, _headers());
  },
  deleteImageById(id) {
    return Api.deleteCall(`/wg_and_pictionary/v1/admin-pictionary-images/${id}`, _headers());
  }
};
